<template>
  <div v-if="settings" id="us-section">
    <img :src="settings.about_image.url" alt="درباره ما میرداماد" />
    <div>
      <h2>درباره ما</h2>
      <p>{{ settings.about_text.value }}</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  metaInfo() {
    return {
      title: "درباره ما",
      meta: [
        {
          name: "description",
          content: this.settings ? this.settings.about_text.value : false
        },
        {
          property: "og:title",
          content: "درباره ما میرداماد"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  }
};
</script>
